import { ReviewForm, ReviewList } from '../../../Reviews'
import { useProduct } from '../../state'
import { Description } from './ProductDetails/Description'
import { ProductDetailsSkeleton } from './ProductDetails/ProductDetailsSkeleton'
import { AutoRelated } from './Related'

/**
 * ProductDetails container - handles loading and error states at parent level
 * Child components (Description, ReviewList, ReviewForm) are presentational only
 */
export function ProductDetails() {
  const { product, loading, error } = useProduct()

  if (loading) {
    return <ProductDetailsSkeleton />
  }

  if (error) {
    return null
  }

  return (
    <>
      <Description />
      <AutoRelated />
      <ReviewList />
      <ReviewForm productSku={product?.sku || ''} productName={product?.name || ''} />
    </>
  )
}
